import React from 'react'
import { addDays, format } from 'date-fns'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import { printOrderSchema } from '../../../schemas'

const MIN_LEAD_DAYS = 10
const minDate = format(addDays(new Date(), MIN_LEAD_DAYS), 'yyyy-MM-dd')
const defaultDate = minDate

export default function New({ account, accounts, navigation, print_assets, positions }) {
  const assetOptions = print_assets.map((pa) => ({
    label: `${pa.name} (${pa.size})`,
    value: pa.id
  }))

  const positionOptions = positions.map((p) => ({
    label: p.name,
    value: p.id,
    group: p.category_label
  }))

  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="New Print Order"
    >
      <BackLink href="/manage/print_orders">Back to Print Orders</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={printOrderSchema}
          resource="print_order"
          endpoint="/manage/print_orders"
          backLink="/manage/print_orders"
          submitLabel="Create Print Order"
          defaultValues={{
            print_asset_id: '',
            date: defaultDate,
            quantity: 1,
            notes: '',
            position_ids: []
          }}
        >
          {({ control, errors }) => (
            <>
              <FormFieldController
                control={control}
                name="print_asset_id"
                label="Print Asset"
                type="select"
                options={assetOptions}
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="date"
                label="Desired delivery date"
                type="date"
                min={minDate}
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="quantity"
                label="Quantity"
                type="number"
                hint="Number of copies per location"
                required
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="position_ids"
                label="Locations"
                type="searchableCheckboxGroup"
                options={positionOptions}
                maxItems={20}
                placeholder="Search locations..."
                emptyMessage="No locations found"
                hint="Select which locations to include in this print order"
                errors={errors}
              />

              <FormFieldController
                control={control}
                name="notes"
                label="Notes"
                type="textarea"
                rows={3}
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
